import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import {ErrorBoundaryWrapper} from "../../../core/components/error-boundary/error-boundary-wrapper";

const LineupsWidgetAsyncComponent = AsyncComponent(async () => import('./lineups-widget' /* webpackChunkName: "lineups-widget" */ ));

export const LineupsWidgetAsync = (props) => {
  return (
    <ErrorBoundaryWrapper isMandatory={!props.isCollapsed}>
      <React.Suspense fallback={<div/>}>
        <LineupsWidgetAsyncComponent {...props}/>
      </React.Suspense>
    </ErrorBoundaryWrapper>
  )
};

